
import React from "react";
import { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

// Use the correct type for the Card component
export interface BrandCardProps extends React.ComponentPropsWithoutRef<typeof Card> {
  gradient?: boolean;
  glassy?: boolean;
  highlighted?: boolean;
  animation?: "fade-in" | "slide-up" | "none";
}

/**
 * Card component that follows the VirtuStaff brand guidelines
 */
export const BrandCard = React.forwardRef<HTMLDivElement, BrandCardProps>(
  ({ gradient, glassy, highlighted, animation = "none", className, children, ...props }, ref) => {
    return (
      <Card
        ref={ref}
        className={cn(
          "rounded-xl overflow-hidden transition-all duration-300 shadow-md",
          highlighted && "border-primary/30 shadow-md shadow-primary/10",
          gradient && "bg-gradient-to-b from-background to-muted/50",
          glassy && "backdrop-blur-md bg-white/10 border border-white/20",
          animation === "fade-in" && "animate-fade-in",
          animation === "slide-up" && "animate-slide-up",
          className
        )}
        {...props}
      >
        {children}
      </Card>
    );
  }
);

BrandCard.displayName = "BrandCard";

// Also export all the original Card subcomponents
export { CardHeader, CardFooter, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
